import "./Footer.css";

export const Footer = () => {
  return (
    <footer className="container-footer">
      <p>
        Mira mi trabajo en <span className="white-text">Github</span> o{" "}
        <span className="white-text">Behance</span>
      </p>
    </footer>
  );
};
